<template>
  <div class="fixed flex inset-0 bg-black bg-opacity-50">
    <slot />
  </div>
</template>
